<template>
  <v-list v-if="getAgent" dense class="py-0">
    <v-divider />

    <v-list-item two-line class="px-3">
      <v-list-item-avatar color="primary" size="26">
        <v-avatar v-if="getAgent.photo">
          <v-img :src="getAgent.photo" />
        </v-avatar>
        <v-avatar v-else color="primary">
          <span class="white--text">
            {{ getAgent.full_name ? getAgent.full_name.substring(0, 1) : "" }}
          </span>
        </v-avatar>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ getAgent.full_name }}</v-list-item-title>
        <v-list-item-subtitle>{{ getAgent.email }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider />

    <PlanOptions v-if="getAgent.role === $roles.ENTREPRENEUR" :show.sync="show" />

    <v-divider />
    <v-row class="pa-1">
      <v-col cols="12" class="d-flex justify-space-around">
        <v-btn icon :to="{ name: 'settings' }">
          <v-icon small> fas fa-cog </v-icon>
        </v-btn>
        <v-btn icon :to="{ name: 'notifications' }">
          <v-icon small> fas fa-bell </v-icon>
        </v-btn>
        <v-btn icon @click="onShowFrequentQuestions">
          <v-icon small> fa fa-question-circle </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-list>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PlanOptions from "./PlanOptions";

export default {
  name: "SettingsOptions",
  components: { PlanOptions },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["getAgent"]),
  },
  methods: {
    ...mapActions(["setShowFrequentQuestionsDrawer"]),
    onShowFrequentQuestions() {
      this.setShowFrequentQuestionsDrawer(true);
    },
  },
};
</script>
